export default __webpack_public_path__ + "img/verif-assure-auto.e239ecae.svg";